import {Cancel, Email, HighlightOffOutlined, ImageOutlined, Phone, UploadFile, WhatsApp} from "@mui/icons-material";
import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Input,
    LinearProgress,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Popover,
    Radio,
    TextField,
    Typography
} from "@mui/material"
import JSDB from "fromKotlin/nk";
import {useEffect, useState} from "react"
import Swal from "sweetalert2";
import {DeviceFloppy, Pencil, User} from "tabler-icons-react";
import {useDispatch, useSelector} from "react-redux";
import {fillCustomers, selectCustomersidname, selectCustomersObjs} from "../../store/customers/customersSlice";
import * as React from "react";
import {changeAllCustomers} from "../../api/customer";
import {callbackNetworkResult, getFile, sendMsgAll, whatsappRefresh} from "../../api/customer/files.api";
import {SNACKBAR_OPEN} from "../../store/actions";
import LoadingButton from "@mui/lab/LoadingButton";
import Draggable from "react-draggable";
import Papper from '@mui/material/Paper';
import {GenerativeLoaderChip, GenerativeLoaderChipSum} from "../GenerativeLoader";
import {buildNotesSum, buildSupNotesSum} from "../../api/customer/documents.api";
import FunctionsOutlinedIcon from "@mui/icons-material/FunctionsOutlined";
import {dateObjectToString, dateObjectToStringIsrael} from "../../fromKotlin/nkutils";
import {getWhatsappConfig, estimateQueuedBulkMinutes, isOfficialHubServer, isWhatsAppServerSkipConnectionCheck} from "../../hooks/useWhatsAppConfig";
import {fetchWhatsAppConnected} from "../../hooks/whatsappConnection";
import { registerWhatsAppSendCompleteCallback } from "../../hooks/useWhatsAppSendLifecycle";
import { isMetaWaTemplateServer, resolveWhatsappMsgForSend, upsertWaImageHeader, clearWaImageHeaderUrl, parseWaImageHeaderUrl, waImageHeaderNeedsUrl } from "../../utils/whatsappPatterns";
import { encodeWhatsappShareText } from "../../utils/whatsappShareUrl";
import HubWhatsappTemplatesButton from "./HubWhatsappTemplatesButton";
import { uploadWhatsappBroadcastImage } from "../../api/customer/whatsapp-image.api";

/** Matches `Utils.DocType.DOC_NAME` by state (NiHulKaVLibBase). */
const DOC_TYPE_LABEL_HE: string[] = [
    "חשבונית מס",
    "חשבונית מס קבלה",
    "חשבונית מס זיכוי",
    "סיכום תעודות",
    "תעודת משלוח",
    "הכל",
    "תעודת ספק",
    "קבלה",
    "מחיר לקוח",
    "כרטסת",
    "הזמנה",
    "תעודת משלוח - החזר",
    "תעודת ביקור",
    "",
    "",
    "",
    "חשבונית ספק",
    "חשבונית ספק - קבלה",
    "חשבונית ספק זיכוי",
    "תשלום לספק",
    "חוב ספק",
    "חשבוניות פתוחות",
    "כרטסת ספק",
    "",
    "",
    "הצעת מחיר",
];

function docTypeLabelHe(state: number): string {
    const s = DOC_TYPE_LABEL_HE[state];
    return s && s.length > 0 ? s : `סוג ${state}`;
}

/** Normalize action_date for wa-open-chat / wa-open-bulk (may arrive as Date or serialized value). */
function normalizeActionDate(value: Date | string | number | undefined): Date | undefined {
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
    if (value != null && value !== '') {
        const d = new Date(value);
        if (!Number.isNaN(d.getTime())) return d;
    }
    return undefined;
}

const SEND_BATCH_SIZE = 30;

type BatchSendProgress = {
    sent: number;
    total: number;
    currentBatch: number;
    totalBatches: number;
};

async function sendMsgAllInBatches(
    ids: number[],
    msg: string,
    title: string,
    docTypes: number[] | undefined,
    emails: string[] | undefined,
    phones: string[] | undefined,
    actionDate: Date | undefined,
    specialArg: string | undefined,
    externalVar: string[] | undefined,
    onProgress: (progress: BatchSendProgress) => void,
): Promise<void> {
    const total = ids.length;
    const totalBatches = Math.ceil(total / SEND_BATCH_SIZE);
    let sent = 0;

    for (let batchIndex = 0; batchIndex < totalBatches; batchIndex++) {
        const start = batchIndex * SEND_BATCH_SIZE;
        const end = Math.min(start + SEND_BATCH_SIZE, total);
        onProgress({sent, total, currentBatch: batchIndex + 1, totalBatches});

        await sendMsgAll(
            ids.slice(start, end),
            msg,
            title,
            docTypes?.slice(start, end),
            emails?.slice(start, end),
            phones?.slice(start, end),
            actionDate,
            specialArg,
            externalVar?.slice(start, end),
        );
        sent = end;
        onProgress({sent, total, currentBatch: batchIndex + 1, totalBatches});
    }
}

const PapperComponent = (props: any) => {
    return (
        <Draggable
            handle="#draggable-gross-message-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Papper {...props} />
        </Draggable>
    );
}

const errorPopup = (errors: any[]) => {
    Swal.fire({
        title: `אירעה שגיאה בעת השליחה`,
        text: `
    ${errors.map((error) => {
            if (error === "no-phone") return "לא נמצא מספר טלפון";
            if (error === "no-email") return "לא נמצא כתובת אימייל";
            if (error === "no-message") return "לא נמצא תוכן הודעה";
        }).join("\n")}
    `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'אישור',
        cancelButtonText: 'בטל'
    }).then((result) => {
        if (result?.isConfirmed) {
            // CONFIRM ALERTS
        }
    })
}

interface ISendMessageDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    toSelected?: string[];
    externalVar?: string[];
    withFiles: boolean;
    files?: {
        ids: number[],
        types: number[]
    };
    defaultPlatform?: "whatsapp" | "email";
    msg?: string;
    subject?: string;
    action_date?: Date;
    onSend?: () => void;
}

const SendMessageDialog = ({
                               open,
                               setOpen,
                               toSelected,
                               files,
                               withFiles,
                               defaultPlatform,
                               subject,
                               msg,
                               onSend,
                               action_date,
                               externalVar
                           }: ISendMessageDialogProps) => {
    const waConfig = React.useMemo(() => getWhatsappConfig(), []);
    const [redirected, setRedirected] = useState(false);
    const onSendRef = React.useRef(onSend);
    onSendRef.current = onSend;

    React.useEffect(() => {
        if (!open) { setRedirected(false); return; }
        if (redirected) return;

        const isNewApi = !!waConfig?.isNewApi;
        if (isOfficialHubServer(waConfig?.server)) return;
        if (!isNewApi) return;
        if (defaultPlatform === 'email') return;
        if (!toSelected?.length) return;

        const hasFiles = !!(files && typeof files === 'object' && !Array.isArray(files) && files.ids?.length);
        // `@payment` must go through SEND_MSG_ALL so the jar creates share URLs one-by-one.
        if (hasFiles || String(msg || '').includes('@payment')) return;

        setRedirected(true);
        setOpen(false);

        const sendCompleteToken = onSendRef.current
            ? registerWhatsAppSendCompleteCallback(() => {
                try {
                    onSendRef.current?.();
                } catch (e) {
                    console.error(e);
                }
            })
            : undefined;

        const resolvedActionDate = normalizeActionDate(action_date);

        if (toSelected.length === 1 && !externalVar?.length) {
            try {
                const client = JSDB().getClient(Number(toSelected[0])).first;
                // Always use current phone for WhatsApp share — not the document/action date.
                const phone = client.getPhoneComplex?.(dateObjectToString(new Date()), 0) || '';
                if (phone) {
                    window.dispatchEvent(new CustomEvent('wa-open-chat', {
                        detail: {
                            phone,
                            clientId: String(toSelected[0]),
                            clientName: client.name,
                            msg: msg || '',
                            sendCompleteToken,
                            actionDate: resolvedActionDate,
                        },
                    }));
                    return;
                }
            } catch { /* fall through to bulk */ }
        }
        window.dispatchEvent(new CustomEvent('wa-open-bulk', {
            detail: {
                clients: toSelected,
                msg: msg || '',
                actionDate: resolvedActionDate,
                externalVars: externalVar || [],
                sendCompleteToken,
            },
        }));
    }, [open, redirected, waConfig?.isNewApi, defaultPlatform, toSelected, files, msg, action_date, externalVar]);

    const [platform, setPlatform] = useState<"whatsapp" | "email">(defaultPlatform || "whatsapp");
    const toOptions: any[] = useSelector(selectCustomersidname);
    const [uploadFiles, setUploadFiles] = useState<File[]>([]);
    const [templateImage, setTemplateImage] = useState<{ name: string; url: string; preview: string } | null>(null);
    const [imageUploading, setImageUploading] = useState(false);
    const url = new URL(window.location.href);
    const pathName = url.pathname;
    const [withLink,setWithLink]=useState(false);
    const [savedMessages, setSavedMessages] = useState<{
        id: number;
        name: string;
        message: string;
    }[]>(localStorage.getItem(`saved-messages-${pathName}`) ? JSON.parse(localStorage.getItem(`saved-messages-${pathName}`) as string) : []);
    const [saveNewMessage, setSaveNewMessage] = useState(false);
    const dispatch = useDispatch()
    const [form, setForm] = useState({
        to: [] as {
            name: string;
            id: string;
            phone?: string;
            email?: string;
            link?: boolean;
        }[],
        subject: "",
        message: "",
        files: [] as string[] | File[],
    })
    const [openUserDetails, setOpenUserDetails] = useState(false);
    const [singleUser, setSingleUser] = useState({
        id: "",
        name: "",
        phone: "",
        email: "",
    });

    const [noPlatform, setNoPlatform] = useState(false);
    const [editPhone, setEditPhone] = useState(false);
    const [editEmail, setEditEmail] = useState(false);
    const [loading, setLoading] = useState(false);
    const [batchProgress, setBatchProgress] = useState<BatchSendProgress | null>(null);
    const isTaxFile = files?.types?.some((type) => type === 0);
    const isNoteFile = files?.types?.some((type) => type === 4);
    const [sendSum, setSendSum] = useState(false);
    const [withPrice, setWithPrice] = useState(undefined);
    // Phone selection checkboxes state
    const [includePhone1, setIncludePhone1] = useState(true);
    const [includePhone2, setIncludePhone2] = useState(false);
    const [includePhone3, setIncludePhone3] = useState(false);
    const canAttachTemplateImage = platform === "whatsapp" && isMetaWaTemplateServer(waConfig);
    const messageHasImageToken = String(form.message || '').includes('@image');
    const showTemplateImage = canAttachTemplateImage && messageHasImageToken;
    const imageHeaderMissingUrl = showTemplateImage && waImageHeaderNeedsUrl(form.message);

    useEffect(() => {
        if (open) return;
        setTemplateImage((prev) => {
            if (prev?.preview) URL.revokeObjectURL(prev.preview);
            return null;
        });
        setImageUploading(false);
    }, [open]);

    const applyTemplateImageUrl = (url: string, fileName: string, preview: string) => {
        setTemplateImage((prev) => {
            if (prev?.preview && prev.preview !== preview) URL.revokeObjectURL(prev.preview);
            return { name: fileName, url, preview };
        });
        setForm((prev) => ({
            ...prev,
            message: upsertWaImageHeader(prev.message, url),
        }));
    };

    const removeTemplateImage = () => {
        setTemplateImage((prev) => {
            if (prev?.preview) URL.revokeObjectURL(prev.preview);
            return null;
        });
        setForm((prev) => ({
            ...prev,
            message: clearWaImageHeaderUrl(prev.message),
        }));
    };

    const onTemplateImagePicked = async (file: File | undefined) => {
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            await Swal.fire({
                title: "יש לבחור תמונה",
                icon: "warning",
                confirmButtonText: "אישור",
            });
            return;
        }
        setImageUploading(true);
        const preview = URL.createObjectURL(file);
        try {
            const url = await uploadWhatsappBroadcastImage(file);
            applyTemplateImageUrl(url, file.name, preview);
        } catch (e: any) {
            URL.revokeObjectURL(preview);
            await Swal.fire({
                title: "העלאת התמונה נכשלה",
                text: e?.message || '',
                icon: "error",
                confirmButtonText: "אישור",
            });
        } finally {
            setImageUploading(false);
        }
    };
    useEffect(() => {
        if (platform === "email") {
            setNoPlatform(form.to.some((user) => !user.email || user.email === ""));
            return;
        }
        if (platform === "whatsapp") {
            // Consider selected phone checkboxes: if none of the selected phone numbers exist for a user, mark missing
            const missingAny = form.to.some((user, index) => {
                const client = JSDB().getClient(Number(user.id)).first;
                const hasP1 = includePhone1 ? (user.phone && user.phone !== "") : false;
                let hasP2 = false, hasP3 = false;
                try { hasP2 = includePhone2 ? (typeof client.getSecondPhone === 'function' ? !!client.getSecondPhone() : false) : false; } catch (e) { hasP2 = false; }
                try { hasP3 = includePhone3 ? (typeof client.getThirdPhone === 'function' ? !!client.getThirdPhone() : false) : false; } catch (e) { hasP3 = false; }
                return !(hasP1 || hasP2 || hasP3);
            });
            setNoPlatform(missingAny);
            return;
        }
        setNoPlatform(false);
    }, [platform, editEmail, editPhone, form.to, includePhone1, includePhone2, includePhone3])

    const sendCallback = React.useCallback(async () => {
        let lastBatchProgress: BatchSendProgress | null = null;
        try {
            setLoading(true)
            if (platform === "whatsapp" && waConfig) {
                const connected = await fetchWhatsAppConnected(waConfig);
                if (!connected) {
                    setLoading(false);
                    await Swal.fire({
                        title: "WhatsApp לא מחובר",
                        html: '<p style="direction:rtl;text-align:right">אין חיבור ל-WhatsApp. התחבר דרך הסטטוס בראש המסך (צ׳יפ אדום) או סרוק QR.</p>',
                        icon: "warning",
                        confirmButtonText: "אישור",
                    });
                    return false;
                }
            }
            const filesOn = files?.ids?.length
            console.log(form)
            const curForm = form.to.filter((user) => (!withLink || user.link) && (platform == "email" ? user.email !== "" : true) && (!filesOn || user.file != undefined && user.type != undefined));
            console.log(curForm)

            // Build ids/doc_types baseline (per selected recipients)
            const baseIds = filesOn ? curForm.map((user) => user.file) : curForm.map((user) => Number(user.id));
            const baseDocTypes = filesOn ? curForm.map((user) => user.type) : undefined;

            // Build contact arrays depending on platform
            let emails: string[] | undefined = undefined;
            let phones: string[] | undefined = undefined;

            if (platform === "email") {
                emails = curForm.map((user) => user.email ?? '');
            } else {
                // whatsapp: expand per selected phone checkboxes

                const idsExpanded: number[] = [];
                const docTypesExpanded: (number | undefined)[] = [];
                const phonesExpanded: string[] = [];
                const varsExpanded: string[] = [];
                // De-dup key: when files are on, allow same phone to repeat across different (id, docType).
                // Key by [phone|id|docType] when filesOn, otherwise key by phone only.
                const seenKeys = new Set<string>();

                curForm.forEach((user, idx) => {
                    const client = JSDB().getClient(Number(user.id)).first;

                    // Helper to push if valid (non-empty) and not duplicate for the specific (phone,id,docType) combination
                    const pushEntry = (phoneVal?: string) => {
                        const val = phoneVal ?? '';
                        const curId = baseIds[idx] as number;
                        const curDocType = filesOn ? baseDocTypes?.[idx] : '';
                        const key = `${val}|${curId}|${curDocType ?? ''}`;

                        if (val && val !== "" && !seenKeys.has(key)) {
                            seenKeys.add(key);
                            phonesExpanded.push(val);
                            idsExpanded.push(curId);
                            if (filesOn) docTypesExpanded.push(curDocType);
                            varsExpanded.push(externalVar?.[idx] ?? '');
                        }
                    };

                    // Phone 1: keep current behavior for phone complex used on init
                    if (includePhone1) {
                        const phone1 = user.phone ?? client.getPhoneComplex(dateObjectToString(new Date()), files?.ids?.[idx] != undefined ? 1 : 0);
                        pushEntry(phone1);
                    }
                    // Phone 2
                    if (includePhone2 && typeof (client as any).getSecondPhone === 'function') {
                        try { pushEntry((client as any).getSecondPhone()); } catch (e) { /* ignore */ }
                    }
                    // Phone 3
                    if (includePhone3 && typeof (client as any).getThirdPhone === 'function') {
                        try { pushEntry((client as any).getThirdPhone()); } catch (e) { /* ignore */ }
                    }
                });

                // Replace base arrays with expanded ones
                phones = phonesExpanded;

                // When expanding, ids/doc_types must match the same length
                if (filesOn) {
                    // @ts-ignore keep runtime safety
                    var ids: any = idsExpanded;
                    var doc_types: any = docTypesExpanded;
                    // continue using expanded in sendMsgAll call below
                } else {
                    // @ts-ignore
                    var ids: any = idsExpanded;
                    // doc_types remains undefined when not filesOn
                    var doc_types: any = undefined;
                }

                // Edge: if none selected, warn by falling back to phone1 to avoid empty send
                if (phones.length === 0) {
                    phones = curForm.map((user) => user.phone ?? '');
                    // and fallback ids/doc_types to base
                    // @ts-ignore
                    ids = baseIds;
                    // @ts-ignore
                    doc_types = baseDocTypes;
                    varsExpanded.length = 0;
                    curForm.forEach((_, idx) => varsExpanded.push(externalVar?.[idx] ?? ''));
                }

                // Now overwrite base arrays for send call
                // @ts-ignore
                emails = undefined;
                // @ts-ignore
                var external_vars: any = varsExpanded;
            }

            // If platform is email, set ids/doc_types from base
            // For WhatsApp, ids/doc_types may have been expanded above via var
            // Using fallback if not defined
            // @ts-ignore
            const idsFinal = typeof ids !== 'undefined' ? ids : baseIds;
            // @ts-ignore
            const docTypesFinal = typeof doc_types !== 'undefined' ? doc_types : baseDocTypes;
            // @ts-ignore
            const externalVarFinal = typeof external_vars !== 'undefined' ? external_vars : externalVar;

            const msg = form.message;
            const subject = form.subject;

            const msgForSend = platform === "whatsapp"
                ? resolveWhatsappMsgForSend({
                    msg,
                    docTypes: docTypesFinal,
                    useMetaTemplates: isMetaWaTemplateServer(waConfig),
                })
                : msg;
            // ADD CALLBACK TO TO SEND SUM IF NEEDED
            if (idsFinal?.length) {
                if (waConfig?.isNewApi && platform === "whatsapp") {
                    const sendCount = idsFinal.length;
                    // Small batches: no queue-time warning — only relevant from 10+ recipients
                    if (sendCount >= 10) {
                        const mins = estimateQueuedBulkMinutes(
                            sendCount,
                            filesOn ? "document" : "message",
                        );
                        const showBulkRateHint = sendCount > 15;
                        const bulkRateParagraph = showBulkRateHint
                            ? `<p style="text-align:right;direction:rtl;color:#666;font-size:0.95em">הערכת קצב לשליחות גדולות: כ-50 מסמכים ≈ 12 דקות, כ-50 הודעות טקסט בלבד ≈ 8 דקות.</p>`
                            : "";
                        const notice = await Swal.fire({
                            title: "שליחה בתור (ווטסאפ)",
                            html:
                                `<p style="text-align:right;direction:rtl">ההודעות נשלחות בהדרגה — לא מיד. לפי מספר השליחות (${sendCount}), זמן משוער: בערך <strong>${mins} דקות</strong>.</p>` +
                                bulkRateParagraph +
                                `<p style="text-align:right;direction:rtl;color:#666;font-size:0.95em">אפשר לעקוב אחרי ההתקדמות בחלון הווטסאפ.</p>`,
                            icon: "info",
                            showCancelButton: true,
                            confirmButtonText: "המשך לשליחה",
                            cancelButtonText: "ביטול",
                        });
                        if (!notice.isConfirmed) {
                            setLoading(false);
                            return false;
                        }
                    }
                }
                let  specialArg = undefined
                if(withPrice && sendSum){
                    specialArg = '3'
                } else if (withPrice){
                    specialArg = '1'
                } else if (sendSum){
                    specialArg = (isNoteFile) ?'2' : '1'
                }
                const emailsForSend = platform == "email" ? emails : undefined;
                const phonesForSend = platform == "whatsapp" ? phones : undefined;

                // Keep every @payment recipient in one backend invocation. The jar serializes
                // session creation and caches one combined link per client; splitting here could
                // create a second link when one client's documents cross a batch boundary.
                if (idsFinal.length >= SEND_BATCH_SIZE && !msgForSend.includes('@payment')) {
                    await sendMsgAllInBatches(
                        idsFinal,
                        msgForSend,
                        subject,
                        docTypesFinal,
                        emailsForSend,
                        phonesForSend,
                        action_date,
                        specialArg,
                        externalVarFinal,
                        (progress) => {
                            lastBatchProgress = progress;
                            setBatchProgress(progress);
                        },
                    );
                    setBatchProgress(null);
                } else {
                    await sendMsgAll(
                        idsFinal,
                        msgForSend,
                        subject,
                        docTypesFinal,
                        emailsForSend,
                        phonesForSend,
                        action_date,
                        specialArg,
                        externalVarFinal,
                    );
                }
            } else {
                setLoading(false)
                return
            }


            // dispatch(fillCustomers());

            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: 'נשלח בהצלחה!',
                variant: 'alert',
                alertSeverity: 'success'
            });
            setOpen(false)
            if (onSend)
                onSend()
            return true
        } catch (e) {
            console.log(e)
            setBatchProgress(null);
            const progressOnFail = lastBatchProgress;
            dispatch({
                type: SNACKBAR_OPEN,
                open: true,
                message: progressOnFail
                    ? `נכשל בשליחה (נשלחו ${progressOnFail.sent} מתוך ${progressOnFail.total})`
                    : 'נכשל בשליחה',
                variant: 'alert',
                alertSeverity: 'error'
            });

        }
        setBatchProgress(null);
        setLoading(false)
        return false

    }, [form, files, sendSum, platform, externalVar, withLink, withPrice, includePhone1, includePhone2, includePhone3, waConfig])
    const whatsappCallBack = () => {
        const to = form.to[0]
        const id = to.id
        const client = JSDB().getClient(Number(id)).first

        let text = form.message

        text = text.replace("#name", client.getName())
        text = text.replace("#id", client.id)
        text = text.replace("#external_id", client.getExternalId())
        text = text.replace("#date", dateObjectToStringIsrael(new Date()))
        text = text.replace("#contact", client.getPhoneContact())
        text = text.replace("#day", JSDB().getDatesManipulator().getDayOfWeekStr(dateObjectToString(new Date()), true))
        text = text.replace("#var", externalVar?.[0] ?? '')

        const row = form.to[0] as { file?: number; type?: number } | undefined;
        if (row && row.file != null && row.type != null) {
            text = text.replace(
                "#docs",
                [client.getName(), `מס׳ ${row.file}`, docTypeLabelHe(row.type)].filter(Boolean).join(" — ")
            );
        } else {
            text = text.replace("#docs", "");
        }

        const url = encodeWhatsappShareText(text);
        const phone = to.phone ?? client.getPhoneComplex(dateObjectToString(new Date()), 0);
        const x = window.open(`https://api.whatsapp.com/send?text=${url}&phone=${JSDB().getValidPhone(phone)}`, '_blank');
        if (x) {
            x.focus();
        }
    };
    useEffect(() => {

        if (open) {
            setLoading(false)
            setBatchProgress(null)
            setPlatform(defaultPlatform || "email")

            const to = toSelected?.map((id, index) => {
                const client = JSDB().getClient(Number(id)).first
                console.log(files?.ids?.[index])
                return {
                    name: client.name,
                    id: Number(id),
                    phone: client.getPhoneComplex(dateObjectToString(new Date()), files?.ids?.[index] != undefined ? 1 : 0),
                    email: client.getEmail().split(",")[0],
                    file: files?.ids?.[index],
                    type: files?.types?.[index],
                    link:client.link
                }
            }) ?? []

            const f = {
                to: to,
                subject: subject ?? "",
                message: msg ?? "",
                files: [],
            }
            if (toSelected) setForm(
                f
            );
            // Reset phone checkboxes defaults on open
            setIncludePhone1(true);
            setIncludePhone2(false);
            setIncludePhone3(false);
        }
    }, [open])
    return (
        <>
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            PaperComponent={PapperComponent}
            aria-labelledby="draggable-gross-message-dialog-title"
        >
            <DialogTitle
                id="draggable-gross-message-dialog-title"
                style={{cursor: 'move'}}
            >
                שלח הודעה
            </DialogTitle>
            <DialogContent>
                <Grid container sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    width: '100%',
                }}>

                    {!isWhatsAppServerSkipConnectionCheck(waConfig?.server) && (
                    <Grid item xs={12}>
                        <div style={{textAlign: 'left'}}>
                            <GenerativeLoaderChip labelText={'רענן חיבור לווטסאפ'} func={(setLoader) => {
                                callbackNetworkResult(whatsappRefresh, () => {
                                }, setLoader)
                            }} icon={<WhatsApp sx={{width: '24px', height: '24px', mr: 0, ml: 0, p: 0}}/>}/>
                        </div>
                    </Grid>
                    )}

                    <Grid item xs={12}>
                        <FormControl
                            fullWidth
                        >
                            <FormLabel>
                                <Typography>
                                    בחר פלטפורמה
                                </Typography>
                            </FormLabel>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <FormControlLabel value={"whatsapp"}
                                                  control={<Radio checked={platform === "whatsapp"}/>} label="וואטצאפ"
                                                  onChange={() => setPlatform("whatsapp")}/>
                                <FormControlLabel value={"email"} control={<Radio checked={platform === "email"}/>}
                                                  label="אימייל" onChange={() => setPlatform("email")}/>
                            </Box>
                        </FormControl>
                    </Grid>

                    {platform === "whatsapp" ? (
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel>
                                    <Typography>
                                        בחר מספרי טלפון לשליחה
                                    </Typography>
                                </FormLabel>
                                <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                    <FormControlLabel
                                        control={<Checkbox checked={includePhone1} onChange={(e) => setIncludePhone1(e.target.checked)} />}
                                        label="מס' טלפון 1"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={includePhone2} onChange={(e) => setIncludePhone2(e.target.checked)} />}
                                        label="מס' טלפון 2"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={includePhone3} onChange={(e) => setIncludePhone3(e.target.checked)} />}
                                        label="מס' טלפון 3"
                                    />
                                </Box>
                            </FormControl>
                        </Grid>
                    ) : null}

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <FormLabel>
                                <Typography>
                                    בחר נמען
                                </Typography>
                            </FormLabel>
                            <Autocomplete
                                sx={{
                                    maxHeight: 200,
                                    overflowY: 'scroll',

                                }}
                                multiple
                                options={toOptions}
                                getOptionLabel={(option) => option?.name}
                                limitTags={files?.ids?.length ?? undefined}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="בחר נמען"
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => Number(option?.id) === Number(value?.id)}
                                value={form?.to ?? []}
                                onChange={(e, value) => {
                                    e?.stopPropagation();
                                    e?.preventDefault();
                                    if (e?.keyCode === 8) {
                                        const user = form.to.find((user) => user.id === singleUser?.id);
                                        if (!user) return;
                                        if (document.activeElement?.id === "send-message-dialog-user-details-phone-input") {
                                            const focusedInput = document.activeElement as HTMLInputElement;
                                            if (focusedInput) {
                                                focusedInput.value = focusedInput.value.slice(0, -1);
                                                setSingleUser({
                                                    ...singleUser,
                                                    phone: focusedInput.value,
                                                })
                                                return;
                                            }
                                            return;
                                        }
                                        if (document.activeElement?.id === "send-message-dialog-user-details-email-input") {
                                            const focusedInput = document.activeElement as HTMLInputElement;
                                            if (focusedInput) {
                                                focusedInput.value = focusedInput.value.slice(0, -1);
                                                setSingleUser({
                                                    ...singleUser,
                                                    email: focusedInput.value,
                                                })
                                                return;
                                            }
                                            return;
                                        }
                                    }
                                    setForm({
                                        ...form,
                                        to: value || [],
                                    })
                                }}
                                renderTags={(value, getTagProps) => {
                                    return value.map((option, index) => {
                                            const customer = form?.to?.[index];


                                            const missing = ((platform === "whatsapp" && (!customer?.phone || customer?.phone === "")) || (platform === "email" && (!customer?.email || customer?.email === "")));
                                            return (
                                                <>
                                                    <Chip
                                                        variant="outlined"
                                                        label={(
                                                            <Box sx={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                gap: 1,
                                                                alignItems: 'center'
                                                            }}>
                                                                <Typography>
                                                                    {customer?.name}
                                                                </Typography>
                                                                <Phone
                                                                    style={{
                                                                        color: !customer?.phone || customer?.phone === "" ? "red" : "inherit",
                                                                        fontSize: 18,
                                                                    }}
                                                                />
                                                                <Email
                                                                    style={{
                                                                        color: !customer?.email || customer?.email === "" ? "red" : "inherit",
                                                                        fontSize: 18,
                                                                    }}
                                                                />
                                                            </Box>
                                                        )}
                                                        id={`send-message-dialog-user-details-${index}`}
                                                        {...getTagProps({index})}
                                                        onDelete={getTagProps({index}).onDelete}

                                                        onClick={() => {
                                                            setSingleUser({
                                                                name: customer?.name || "",
                                                                phone: customer?.phone || "",
                                                                email: customer?.email || "",
                                                                id: customer?.id || "",
                                                            });
                                                            setOpenUserDetails(true)
                                                        }}
                                                        style={{
                                                            backgroundColor: missing ? "#ff4e007d" : "#ede7f6",
                                                            fontWeight: missing ? "bold" : "normal",
                                                        }}
                                                    />
                                                    <Popover
                                                        open={openUserDetails && (option?.id) === singleUser?.id}
                                                        anchorEl={() => document.getElementById(`send-message-dialog-user-details-${index}`) as HTMLElement}
                                                        onClose={() => {
                                                            setOpenUserDetails(false)
                                                            setEditEmail(false);
                                                            setEditPhone(false);
                                                        }}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'center',
                                                        }}

                                                    >
                                                        <Box sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 2,
                                                            padding: 2
                                                        }}>
                                                            <Typography sx={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                gap: 1,
                                                                alignItems: 'center',
                                                            }}>
                                                                <User/> {singleUser?.name}
                                                            </Typography>
                                                            {editPhone ? (
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    gap: 1,
                                                                    alignItems: 'center',
                                                                }}>
                                                                    <TextField
                                                                        label="טלפון"
                                                                        value={singleUser?.phone}
                                                                        onChange={(e) => {
                                                                            // callback to update the user phone
                                                                            const user = form.to.find((user) => user.id === singleUser?.id);
                                                                            if (user) {
                                                                                setForm(
                                                                                    {
                                                                                        ...form,
                                                                                        to: form.to.map((u) => {
                                                                                            if (u.id === user.id) {
                                                                                                u.phone = e.target.value;
                                                                                            }
                                                                                            return u;
                                                                                        })
                                                                                    }
                                                                                )
                                                                            }
                                                                            setSingleUser({
                                                                                ...singleUser,
                                                                                phone: e.target.value,
                                                                            })
                                                                        }}
                                                                        id="send-message-dialog-user-details-phone-input"
                                                                        onClick={() => {
                                                                            setEditPhone(true);
                                                                            setTimeout(() => {
                                                                                document.getElementById("send-message-dialog-user-details-phone-input")?.focus();
                                                                            }, 100);
                                                                        }}
                                                                    />
                                                                    <DeviceFloppy
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            // callback to save the phone
                                                                            setEditPhone(false);
                                                                        }}
                                                                    />
                                                                </Box>
                                                            ) : (
                                                                <Typography sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    gap: 1,
                                                                    alignItems: 'center',
                                                                    fontWeight: !singleUser?.phone || singleUser?.phone === "" ? "bold" : "normal",
                                                                }}>
                                                                    <Phone
                                                                        style={{
                                                                            color: !singleUser?.phone || singleUser?.phone === "" ? "red" : "inherit",
                                                                        }}
                                                                    />{singleUser?.phone || "לא קיים"}
                                                                    <Pencil style={{
                                                                        cursor: 'pointer',
                                                                        zIndex: 1000,
                                                                    }}
                                                                            onClick={() => {
                                                                                setEditPhone(true);
                                                                                setTimeout(() => {
                                                                                    document.getElementById("send-message-dialog-user-details-phone-input")?.focus();
                                                                                }, 100);
                                                                            }}
                                                                    />
                                                                </Typography>
                                                            )
                                                            }
                                                            {editEmail ? (
                                                                <Box sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    gap: 1,
                                                                    alignItems: 'center',
                                                                }}>
                                                                    <TextField
                                                                        label="אימייל"
                                                                        value={singleUser?.email}
                                                                        onChange={(e) => {
                                                                            // callback to update the user email
                                                                            const user = form.to.find((user) => user.id === singleUser?.id);
                                                                            if (user) {
                                                                                setForm(
                                                                                    {
                                                                                        ...form,
                                                                                        to: form.to.map((u) => {
                                                                                            if (u.id === user.id) {
                                                                                                u.email = e.target.value;
                                                                                            }
                                                                                            return u;
                                                                                        })
                                                                                    }
                                                                                )
                                                                            }
                                                                            setSingleUser({
                                                                                ...singleUser,
                                                                                email: e.target.value,
                                                                            })
                                                                        }}
                                                                        id="send-message-dialog-user-details-email-input"
                                                                        onClick={() => {
                                                                            setEditEmail(true);
                                                                            setTimeout(() => {
                                                                                document.getElementById("send-message-dialog-user-details-email-input")?.focus();
                                                                            }, 100);
                                                                        }}
                                                                    />
                                                                    <DeviceFloppy
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                        }}
                                                                        onClick={() => {
                                                                            // callback to save the email
                                                                            setEditEmail(false);
                                                                        }}
                                                                    />
                                                                </Box>
                                                            ) : (
                                                                <Typography sx={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    gap: 1,
                                                                    alignItems: 'center',
                                                                    fontWeight: !singleUser?.email || singleUser?.email === "" ? "bold" : "normal",
                                                                }}>
                                                                    <Email
                                                                        style={{
                                                                            color: !singleUser?.email || singleUser?.email === "" ? "red" : "inherit",
                                                                        }}
                                                                    />{singleUser?.email || "לא קיים"}
                                                                    <Pencil style={{
                                                                        cursor: 'pointer',
                                                                        zIndex: 1000,
                                                                    }}
                                                                            onClick={() => {
                                                                                setEditEmail(true);
                                                                                setTimeout(() => {
                                                                                    document.getElementById("send-message-dialog-user-details-email-input")?.focus();
                                                                                }, 100);
                                                                            }}
                                                                    />
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    </Popover>
                                                </>
                                            )
                                        }
                                    )
                                }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <FormLabel>
                                <Typography>
                                    נושא
                                </Typography>
                            </FormLabel>
                            <TextField
                                variant="outlined"
                                placeholder="נושא"
                                value={form?.subject || ""}
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        subject: e.target.value,
                                    })
                                }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 1,
                    }}>
                        {
                            savedMessages?.length ? savedMessages?.map((message) => (
                                <Chip
                                    variant="outlined"
                                    label={message.name}
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: message.message,
                                        })
                                    }}
                                    icon={<Cancel style={{color: "red"}} onClick={() => {
                                        setSavedMessages(savedMessages.filter((m) => m.id !== message.id))
                                        localStorage.setItem(`saved-messages-${pathName}`, JSON.stringify(savedMessages.filter((m) => m.id !== message.id)))
                                    }}/>}
                                />
                            )) : null
                        }
                        {
                            saveNewMessage ? (
                                <div style={{
                                    display: "flex"
                                }}>
                                    <Input type="text" placeholder="שם" id="save-new-message-chip"/>
                                    <DeviceFloppy onClick={() => {
                                        const name = document.getElementById("save-new-message-chip")?.value;
                                        if (name) {
                                            setSavedMessages([...savedMessages, {
                                                id: savedMessages.length,
                                                name: name,
                                                message: form.message,
                                            }])
                                            localStorage.setItem(`saved-messages-${pathName}`, JSON.stringify([...savedMessages, {
                                                id: savedMessages.length,
                                                name: name,
                                                message: form.message,
                                            }]))
                                        }
                                        setSaveNewMessage(false);
                                    }}
                                                  style={{
                                                      cursor: 'pointer',
                                                      color: "blue"
                                                  }}
                                    />
                                    <Cancel
                                        style={{
                                            cursor: 'pointer',
                                            color: "red"
                                        }}
                                        onClick={() => {
                                            setSaveNewMessage(false)
                                        }}
                                    />
                                </div>
                            ) : (
                                <Chip
                                    variant="outlined"
                                    label="שמור הודעה"
                                    onClick={() => {
                                        setSaveNewMessage(true)
                                    }}
                                />
                            )
                        }
                        {form?.to?.length == 1 ? (<Chip
                            variant="filled"
                            label="ווטסאפ דסק"
                            color={"success"}
                            onClick={() => {
                                whatsappCallBack()
                            }}
                        />) : undefined}

                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <FormLabel>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                }}>
                                    <Typography>
                                        הודעה
                                    </Typography>
                                    {platform === 'whatsapp' && isOfficialHubServer(waConfig?.server) ? (
                                        <HubWhatsappTemplatesButton
                                            waConfig={waConfig}
                                            onSelect={(pattern) => {
                                                const url = templateImage?.url || parseWaImageHeaderUrl(form.message);
                                                setForm({
                                                    ...form,
                                                    message: url ? upsertWaImageHeader(pattern, url) : pattern,
                                                });
                                                document.getElementById('send-message-dialog-message-input')?.focus();
                                            }}
                                        />
                                    ) : null}
                                </Box>
                            </FormLabel>
                            <TextField
                                id="send-message-dialog-message-input"
                                multiline
                                rows={4}

                                variant="outlined"
                                placeholder="הודעה"
                                onChange={(e) => {
                                    setForm({
                                        ...form,
                                        message: e.target.value,
                                    })
                                }}
                                value={form?.message || ""}
                            />
                        </FormControl>
                    </Grid>

                    {showTemplateImage ? (
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel>
                                    <Typography>
                                        תמונה לתבנית
                                    </Typography>
                                </FormLabel>
                                <input
                                    type="file"
                                    id="send-message-dialog-template-image"
                                    hidden
                                    accept="image/jpeg,image/png,image/webp,image/gif"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        e.target.value = '';
                                        void onTemplateImagePicked(file);
                                    }}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                    <Chip
                                        variant="outlined"
                                        icon={imageUploading ? <CircularProgress size={16} /> : <ImageOutlined />}
                                        label={imageUploading ? 'מעלה תמונה…' : (templateImage ? 'החלף תמונה' : 'העלה תמונה')}
                                        disabled={imageUploading || loading}
                                        onClick={() => document.getElementById('send-message-dialog-template-image')?.click()}
                                    />
                                    {templateImage ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box
                                                component="img"
                                                src={templateImage.preview}
                                                alt=""
                                                sx={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 1 }}
                                            />
                                            <Typography variant="body2">{templateImage.name}</Typography>
                                            <HighlightOffOutlined
                                                style={{ cursor: 'pointer', color: 'red' }}
                                                onClick={removeTemplateImage}
                                            />
                                        </Box>
                                    ) : null}
                                </Box>
                                {imageHeaderMissingUrl ? (
                                    <Typography variant="caption" color="error">
                                        בחרו תבנית תמונה והעלו תמונה — ייכתב @image עם קישור ציבורי
                                    </Typography>
                                ) : (
                                    <Typography variant="caption" color="text.secondary">
                                        התמונה עולה ל-AWS ומצורפת כ-@image=https://…
                                    </Typography>
                                )}
                            </FormControl>
                        </Grid>
                    ) : null}

                    {isTaxFile ?
                        <Grid item xs={12}>
                            <FormControlLabel
                                value={sendSum}
                                control={<Checkbox color="primary" checked={sendSum} onChange={() => {
                                    setSendSum(!sendSum);
                                }}/>}
                                label="שלח סיכום"
                                labelPlacement="start"
                            />
                        </Grid>
                        : null
                    } {isNoteFile ?
                    <>  <Grid item xs={4}>
                        <FormControlLabel
                            value={withPrice}
                            control={<Checkbox color="primary" checked={withPrice} onChange={() => {
                                setWithPrice(!withPrice);
                            }}/>}
                            label="עם מחירים"
                            labelPlacement="start"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <FormControlLabel
                            value={sendSum}
                            control={<Checkbox color="primary" checked={sendSum} onChange={() => {
                                setSendSum(!sendSum);
                            }}/>}
                            label="סהכ בלבד"
                            labelPlacement="start"
                        />
                    </Grid>
                    </>
                    : null
                }

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <FormLabel>
                                <Typography>
                                    תבניות
                                </Typography>
                            </FormLabel>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 1,
                                flexWrap: 'wrap',
                            }}>
                                <Chip
                                    variant="outlined"
                                    label="#מזהה"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #id ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#שם"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #name ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#איש קשר"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #contact ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#תאריך"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #date ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />

                                <Chip
                                    variant="outlined"
                                    label="#לינק"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #link ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();

                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#לינק החזרות"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #link_returns ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#מסמך"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #docs ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#סכום"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #var ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#מזהה חיצוני"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #external_id ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();
                                    }}
                                />
                                <Chip
                                    variant="outlined"
                                    label="#יום"
                                    onClick={() => {
                                        setForm({
                                            ...form,
                                            message: form.message + " #day ",
                                        })
                                        document.getElementById("send-message-dialog-message-input")?.focus();

                                    }}
                                />
                            </Box>
                        </FormControl>
                    </Grid>

                    {withFiles ? (
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <FormLabel>
                                    <Typography>
                                        קבצים
                                    </Typography>
                                </FormLabel>
                                {
                                    files?.ids?.length ? (
                                        <Autocomplete
                                            multiple
                                            options={files?.ids.map((option) => option) || []}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    placeholder="בחר קבצים"
                                                />
                                            )}
                                            onChange={(e, value) => {
                                                const ids = value?.map((name) => files?.ids.find((t) => t === name)) || []
                                                setForm({
                                                    ...form,
                                                    files: [...form.files, ...ids] as string[] | File[],
                                                })
                                            }}
                                        />
                                    ) : (
                                        <>
                                            <input type="file" id="send-message-dialog-uplkad-file" hidden multiple
                                                   onChange={(e) => {
                                                       const files = e.target.files
                                                       if (files && files?.length > 1) {
                                                           const validFiles: File[] = []
                                                           for (let i = 0; i < files.length; i++) {
                                                               const file = files[i]
                                                               if ((fileTypes && fileTypes?.includes(file.type)) || !fileTypes) {
                                                                   validFiles.push(file)
                                                               }
                                                           }
                                                       } else {
                                                           const file = files?.[0]
                                                           if (file && (fileTypes && fileTypes?.includes(file.type) || !fileTypes)) {
                                                               setUploadFiles([...uploadFiles, file])
                                                           }
                                                       }
                                                   }}
                                            />
                                            <UploadFile style={{
                                                cursor: 'pointer',
                                            }}
                                                        onClick={() => document.getElementById("send-message-dialog-uplkad-file")?.click()}/>
                                        </>
                                    )
                                }
                            </FormControl>
                            {
                                uploadFiles?.length ? (
                                    <Box sx={{display: 'flex', flexDirection: 'row', gap: 2, marginTop: "5px"}}>
                                        {
                                            uploadFiles?.map((file) => (
                                                <Typography sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                }}>
                                                    <HighlightOffOutlined style={{
                                                        cursor: 'pointer',
                                                        color: 'red',
                                                        marginLeft: "5px"
                                                    }}
                                                                          onClick={() => setUploadFiles(uploadFiles.filter((f) => f !== file))}/> {file.name}
                                                </Typography>
                                            ))
                                        }
                                    </Box>
                                ) : null
                            }
                        </Grid>
                    ) : null
                    }
                    {/* Add a checkbox at the end to control the 'withLink' parameter */}
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={withLink}
                                    onChange={(e) => setWithLink(e.target.checked)}
                                />
                            }
                            label="לקוחות שסומנו שניתן לשלוח אליהם בלבד"
                        />
                    </Grid>
                    {batchProgress ? (
                        <Grid item xs={12}>
                            <Box sx={{
                                p: 1.5,
                                borderRadius: 1,
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'action.hover',
                            }}>
                                <Typography variant="body2" fontWeight={600} sx={{mb: 0.5, textAlign: 'right'}}>
                                    {files?.ids?.length ? 'שולח מסמכים' : 'שולח הודעות'} — {batchProgress.sent} / {batchProgress.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{display: 'block', mb: 1, textAlign: 'right'}}>
                                    קבוצה {batchProgress.currentBatch} מתוך {batchProgress.totalBatches}
                                    {' '}(עד {SEND_BATCH_SIZE} בכל קריאה)
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={batchProgress.total > 0
                                        ? Math.round((batchProgress.sent / batchProgress.total) * 100)
                                        : 0}
                                    sx={{height: 8, borderRadius: 1}}
                                />
                            </Box>
                        </Grid>
                    ) : null}

                    <Grid item xs={12} sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 2,
                    }}>

                        <LoadingButton
                            variant="contained"
                            fullWidth
                            loading={loading}
                            color={noPlatform ? "error" : "primary"}
                            disabled={(form.to?.length === 0 && !form.to?.length) || form.subject.length == 0 || form.message.length == 0 || loading || imageUploading || imageHeaderMissingUrl}
                            onClick={() => {
                                sendCallback()
                            }}>
                            {
                                "שלח רק למי שאפשר"
                            }
                        </LoadingButton>
                        <LoadingButton
                            variant="contained"
                            fullWidth
                            loading={loading}
                            color={noPlatform ? "error" : "primary"}
                            disabled={noPlatform || (form.to?.length === 0 && !form.to?.length) || form.subject.length == 0 || form.message.length == 0 || loading || imageUploading || imageHeaderMissingUrl}
                            onClick={() => {
                                sendCallback()
                            }}>
                            {
                                noPlatform ? `לאחד הלקוחות אין פרטי ${platform === "email" ? "אימייל" : "פלאפון"}` : "שלח"
                            }
                        </LoadingButton>

                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            onClick={() => {
                                setOpen(false)
                                setUploadFiles([])
                            }}>
                            בטל
                        </Button>
                    </Grid>


                </Grid>
            </DialogContent>
        </Dialog>
        </>
    )
}

export default SendMessageDialog
